// extracted by mini-css-extract-plugin
export var box = "_5f-1";
export var checkboxRow = "_5f-8";
export var checked = "_5f-2";
export var descriptionSpacer = "_5f-a";
export var disabled = "_5f-3";
export var icon = "_5f-6";
export var input = "_5f-0";
export var labelSpacer = "_5f-9";
export var medium = "_5f-5";
export var small = "_5f-4";
export var text = "_5f-7";